import {AuditRef, PagespeedLHR} from "@/pages/pagespeed/types.ts";

export const getOpportunities = (lhr: PagespeedLHR) => {
  return lhr.categories.performance.auditRefs
    ?.filter((ref) => {
      const details = lhr.audits[ref.id].details;
      // @ts-expect-error legacy
      return details && details.type === "opportunity" && details.overallSavingsMs > 0;
    })
    .map((ref) => prepareAuditData(lhr, ref.id))
    .sort((a, b) =>
      a.details.overallSavingsMs > b.details.overallSavingsMs
        ? -1
        : b.details.overallSavingsMs > a.details.overallSavingsMs
          ? 1
          : 0
    );
};

export const prepareAuditData = (lhr: unknown, auditId: string) => {
  // @ts-expect-error legacy
  const auditData = lhr.audits[auditId];
  auditData.impacting = [];

  // add category and related Core Web Vitals metrics
  // @ts-expect-error legacy
  for (const catId in lhr.categories) {
    // @ts-expect-error legacy
    const cat = lhr.categories[catId];
    for (const auditRef of cat.auditRefs) {
      if (auditRef.id == auditId) {
        auditData.category = catId;
        auditData.categoryTitle = cat.title;
        auditData.weight = auditRef.weight;
      }
      if (auditRef.relevantAudits) {
        for (const relAuditId of auditRef.relevantAudits) {
          if (relAuditId == auditId) {
            auditData.impacting.push(auditRef.acronym);
          }
        }
      }
    }
  }
  return auditData;
};

export const filterAuditRefs = (auditRefs: AuditRef[]) => {
  return auditRefs.filter((auditRef) => auditRef.group !== "metrics" && auditRef.group !== "hidden");
};

export const removeLinksFromMarkdown = (text: string) => {
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)\.?/g; // Regular expression to match link syntax
  return text.replace(linkRegex, ""); // Replace all links with their text content
};
